import { creditUtilizationArticle } from "./articles/creditUtilization";
import { creditScoreImprovementArticle } from "./articles/creditScoreImprovement";
import { creditCardMinimumArticle } from "./articles/creditCardMinimum";
import { balanceTransferArticle } from "./articles/balanceTransfer";
import { creditLimitIncreaseArticle } from "./articles/creditLimitIncrease";
import { cagrArticle } from "./articles/cagr";
import { portfolioRebalancingArticle } from "./articles/portfolioRebalancing";
import { expenseRatioArticle } from "./articles/expenseRatio";
import { assetAllocationArticle } from "./articles/assetAllocation";
import { dollarCostAveragingArticle } from "./articles/dollarCostAveraging";
import { indexFundArticle } from "./articles/indexFund";
import { brokerageFeeArticle } from "./articles/brokerageFee";
import { investmentInflationArticle } from "./articles/investmentInflation";
import { realReturnArticle } from "./articles/realReturn";
import { dripCalculatorArticle } from "./articles/dripCalculator";
import { aprCalculatorArticle } from "./articles/aprCalculator";

export const creditInvestmentArticles: Record<string, string> = {
  "apr-calculator": aprCalculatorArticle,
  "credit-utilization": creditUtilizationArticle,
  "credit-score-improvement": creditScoreImprovementArticle,
  "credit-card-minimum": creditCardMinimumArticle,
  "balance-transfer": balanceTransferArticle,
  "credit-limit-increase": creditLimitIncreaseArticle,
  "cagr": cagrArticle,
  "portfolio-rebalancing": portfolioRebalancingArticle,
  "expense-ratio": expenseRatioArticle,
  "asset-allocation": assetAllocationArticle,
  "dollar-cost-averaging": dollarCostAveragingArticle,
  "index-fund": indexFundArticle,
  "brokerage-fee": brokerageFeeArticle,
  "investment-inflation": investmentInflationArticle,
  "real-return": realReturnArticle,
  "drip-calculator": dripCalculatorArticle,
};
